import Navbar from './Navbar';
import Footer from './Footer';
import FloatingContact from './FloatingContact';

export default function Layout({ children }) {
  return (
    <>
      <Navbar />
      <main className="pt-[120px] md:pt-[160px] min-h-screen bg-[hsl(var(--bb-ivory))] text-[hsl(var(--bb-text))]">
        {children}
      </main>
      <Footer />
      <FloatingContact />
    </>
  );
}
